<ion-app>
  <header class="top-badges">
    <app-lang-switcher></app-lang-switcher>
    <app-theme-toggle class="badge-toggle" [iconOnly]="true"></app-theme-toggle>
    <div class="eu-badge glass-card">
      <span class="flag">🇪🇺</span>
      <span class="label">Made in the EU</span>
    </div>
  </header>
  <ion-router-outlet (activate)="onActivate($event)"></ion-router-outlet>
  <app-cookie-consent-dialog></app-cookie-consent-dialog>
</ion-app>
